import * as React from 'react';

import usePermissions from 'hooks/usePermissions';
import { useTestNotification, useTriggerSecurityEventNotification } from 'security-app/hooks/useSecurityEventsAPI';
import type { EventProcedureStepAPIType } from 'security-app/hooks/api/eventProceduresAPI.types';

import StepActionButton from './StepActionButton';

type Props = {
  eventId?: string;
  config: EventProcedureStepAPIType['action']['config'];
};

function StepSendNotification({ config, eventId = undefined }: Props) {
  const { notification_id } = config;

  const { isPermitted } = usePermissions();
  const disabled = !isPermitted(`eventnotifications:edit:${notification_id}`);

  const { triggerSecurityEventNotification, triggeringSecurityEventNotification } =
    useTriggerSecurityEventNotification();
  const { testNotification, testingNotification } = useTestNotification();

  const onClick = React.useCallback(() => {
    if (eventId) {
      triggerSecurityEventNotification({ id: eventId, notificationId: notification_id });
    } else {
      testNotification({ id: notification_id });
    }
  }, [eventId, notification_id, triggerSecurityEventNotification, testNotification]);

  return (
    <StepActionButton
      hint={disabled ? "You don't have access to execute this notification" : undefined}
      title={eventId ? 'Send Notification' : 'Test Notification'}
      onClick={disabled ? null : onClick}
      disabled={disabled || triggeringSecurityEventNotification || testingNotification}
    />
  );
}

export default StepSendNotification;
